import { useFormContext } from 'react-hook-form';
import { Grid } from '@mui/material';
import WSTextField from '../../../Components/TextBox/WSTextBox';
import WSPhone from '../../../Components/Phone/WSPhone';

export const Step2Contact = () => {
  const { control } = useFormContext();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        {/* <TextField label="Official Email" fullWidth {...register('officialEmail')} />0 */}
        <WSTextField id="officialMail" label={"Official Email"} control={control} name='officialEmail' />
      </Grid>
      <Grid item xs={12} sm={6}>
        {/* <TextField label="Personal Email" fullWidth {...register('personalEmail')} /> */}
        <WSTextField id="personalEmail" label={"Personal Email"} control={control} name='personalEmail' />
      </Grid>
      <Grid item xs={12} sm={6}>
        {/* <WSTextField id="mobileNumber" label={"Mobile Number"} control={control} name='mobileNumber' /> */}
        <WSPhone id="mobileNumber" label={"Mobile Number"} control={control} name='mobileNumber'/>
        {/* <TextField label="Mobile Number" fullWidth {...register('mobileNumber')} /> */}
      </Grid>
      <Grid item xs={12} sm={6}>
        {/* <TextField label="Alternate Contact" fullWidth {...register('altContact')} /> */}
        {/* <WSTextField id="altContact" label={"Alternate Contact"} control={control} name='altContact' /> */}
        <WSPhone id="altContact" label={"Alternate Contact"} control={control} name='altContact'/>
      </Grid>
      <Grid item xs={12}>
        {/* <TextField label="Present Address" fullWidth {...register('presentAddress')} /> */}
        <WSTextField id="presentAddress" label={"Present Address"} control={control} name='permanentAddress' />
      </Grid>
      <Grid item xs={12}>
        <WSTextField id="permanentAddress" label={"Permanent Address"} control={control} name='permanentAddress' />
        {/* <TextField label="Permanent Address" fullWidth {...register('permanentAddress')} /> */}
      </Grid>
      <Grid item xs={12} sm={6}>
        {/* <TextField label="City" fullWidth {...register('city')} /> */}
        <WSTextField id="city" label={"City"} control={control} name='city' />
      </Grid>
      <Grid item xs={12} sm={6}>
        {/* <TextField label="State" fullWidth {...register('state')} /> */}
        <WSTextField id="state" label={"State"} control={control} name='state' />
      </Grid>
      <Grid item xs={12} sm={6}>
        {/* <TextField label="Country" fullWidth {...register('country')} /> */}
        <WSTextField id="country" label={"Country"} control={control} name='country' />
      </Grid>
      <Grid item xs={12} sm={6}>
        <WSTextField id="pinCode" label={"PIN Code"} control={control} name='pinCode' />
        {/* <TextField label="PIN Code" fullWidth {...register('pinCode')} /> */}
      </Grid>
    </Grid>
  );
};